import * as Actions from './actions.js'

// define initial state of all possible properties
export const initialState = {
  error: false,
  loading: true,
  file: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: false,
        file: null
      }

    case Actions.GET_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        file: action.file
      }

    case Actions.GET_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case Actions.CLEAR_DOCUMENT:
      return initialState

    default:
      return state
  }
}
